import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../../components/grid";
import { deshabilitarIcono, obtenerListaIconos } from "../../../api/gestionar-imagenes";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
// import {
//   INT_TIPO_USUARIO_ADMINISTRADOR_WEB,
// } from "../../../utils/const-int";
// import { obtenerPermisosPorNivelUsuarioWeb } from "../../../api/permisos/permisos";
// import { TRUE } from "../../../utils/const-bool";
import cargandoCard from "../../../components/cargando-card";
import SinAccesoCard from "../../../components/sin-acceso-card";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO } from "../../../utils/const/estilos-const";
import { useTranslation } from "react-i18next";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from "../../../utils/const/string-const";
import { obtenerPermisos } from "../../../api/api-permisos";
import { PAGE_ID } from "../../../utils/const/pages-const";
import { INT_TIPO_USUARIO_ADMINISTRADOR_WEB } from "../../../utils/const/int-const";

const idTipoUsuario = localStorage.getItem(STRING_TIPO_USUARIO_CHECKLIST);
const idSubTipoUsuarioWeb = localStorage.getItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);

export default function ListarIconos() {
  const { t } = useTranslation();
  const headers = [
    { key: "acciones", title: t('column_acciones') },
    { key: "id", title: "CODIGO", visible: false, },
    { key: "descripcion", title: t('column_nombre'), filter: true },
    { key: "url", title: t('column_url'), filter: true, esUrl: true, },
    { key: "fechaProceso", title: t('column_fecha_proceso'), filter: true },
  ];
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listaIconos, setListaIconos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [iconoSelected, setIconoSelected] = useState(null);
  const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);

  const [btnNuevo, setBtnNuevo] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
      if (colorBase !== null) {
        setColorMain(colorBase);
      }
      let permiso = null;
      let listarIconos = [];
      listarIconos = await obtenerListaIconos();
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(true);
        setTieneAccesoAlModulo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        const objEnviar = {
          idSubTipoUsuarioWeb: idSubTipoUsuarioWeb,
        };
        const permisos = await obtenerPermisos(objEnviar);
        if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
          permiso = permisos.data[0];
          const permisosInfo = JSON.parse(permisos.data[0].permisos);
          // console.log('permisosInfo');
          // console.log(permisosInfo);
          const permisosPage = permisosInfo.find(e => e.value === PAGE_ID.GESTIONAR_ICONOS);
          // console.log('permisosPage');
          // console.log(permisosPage);
          setTieneAccesoAlModulo(permisosPage.checked === true);
        }
      }

      agregarAccionesALista(listarIconos, permiso);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const agregarAccionesALista = (lista, permiso) => {
    try {
      if (lista.length === 0) {
        setListaIconos(lista);
        return;
      }
      const objDeshabilitar = {
        label: t('btn_deshabilitar'),
        color: "red",
        onClick: (param) => cambiarEstado(param),
      };
      const objVer = {
        label: t('btn_ver'),
        color: "green",
        onClick: (param) => verIcono(param),
      };
      let btnDeshabilitar = false;
      let btnVer = false;
      let btnNuevo = false;
      if (permiso !== null) {
        const parsePermisos = JSON.parse(permiso.permisos);
        const permisosIconos = parsePermisos.find(e => e.value === PAGE_ID.GESTIONAR_ICONOS);
        if (permisosIconos !== undefined) {
          const acciones = permisosIconos.acciones;
          if (acciones !== undefined) {
            const ver = acciones.find(e => e.value === 'btn_ver');
            if (ver !== undefined) {
              btnVer = ver.checked;
            }
            const deshabilitar = acciones.find(e => e.value === 'btn_deshabilitar');
            if (deshabilitar !== undefined) {
              btnDeshabilitar = deshabilitar.checked;
            }
            const nuevo = acciones.find(e => e.value === 'btn_nuevo');
            if (nuevo !== undefined) {
              btnNuevo = nuevo.checked;
            }
          }
        }
      }
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(btnNuevo);
      }
      for (let i = 0; i < lista.length; i++) {
        let acciones = [];
        if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          acciones.push(objDeshabilitar);
          acciones.push(objVer);
        }
        if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          if (btnDeshabilitar === true) {
            acciones.push(objDeshabilitar);
          }
          if (btnVer === true) {
            acciones.push(objVer);
          }
        }
        lista[i].acciones = acciones;
      }
      setListaIconos(lista);
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const nextPage = (page, params) => {
    try {
      // history.push(`${page}`);
      // console.log('params');
      // console.log(params);
      if (params !== undefined && params !== null) {
        if (params.acciones !== undefined) {
          delete params.acciones;
        }
        // console.log('params sin acciones');
        // console.log(params);
        history.push({
          pathname: `${page}`,
          state: params
        });
      } else {
        history.push(`${page}`);
      }
    } catch (err) {
      console.log('nextPage err');
      console.log(err);
    }
  };

  const verIcono = (data) => {
    try {
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      // console.log("verIcono");
      // console.log(data);
      window.open(data.url, '_blank');
    } catch (err) {
      console.log("verIcono err");
      console.log(err);
    }
  };

  const cambiarEstado = async (data) => {
    try {
      // console.log("cambiarEstado");
      // console.log(data);
      setIconoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstado err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.nombre = "";
    obj.titulo = t('titulo_agregar_icono');
    obj.params = data;
    nextPage("icono", obj);
  }

  const handleAtrasClick = () => {
    history.goBack();
  }

  const reset = async () => {
    setCargandoPage(true);
    let listarIconos = await obtenerListaIconos();
    // console.log("listarIconos");
    // console.log(listarIconos);
    agregarAccionesALista(listarIconos, permisos);
    setCargandoPage(false);
  }

  const handleCancelModal = () => {
    setModalConfirmarDeshabilitarVisible(false);
  }

  const handleConfirmModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (iconoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = iconoSelected.id;
    if (iconoSelected.id > 0) {
      // console.log('crear correo');
      let deshabilitado = await deshabilitarIcono(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (deshabilitado === true) {
        alert(t('alert_se_deshabilito_correctamente'));
        reset();
      }
      if (deshabilitado === false) {
        alert(t('alert_no_se_pudo_deshabilitar'));
      }
    }
  }

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return SinAccesoCard();
      }
      return (
        <div className="pt-4">
          <div
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingRight: 10,
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <label
              style={{
                paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              {t('titulo_gestionar_iconos')}
            </label>
            <div>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={handleNuevoClick}
                style={{ backgroundColor: colorMain }}
              >
                {t('btn_nuevo')}
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                {t('btn_atras')}
              </button>
            </div>
          </div>
          <Grid rows={listaIconos} headers={headers} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={handleCancelModal}
            onConfirm={handleConfirmModal}
            message={t('alert_esta_seguro_de_deshabilitar_icono')}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarIconos render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
